import { render, staticRenderFns } from "./understanding-hair-structure.vue?vue&type=template&id=d5c01996&scoped=true&"
import script from "./understanding-hair-structure.vue?vue&type=script&lang=js&"
export * from "./understanding-hair-structure.vue?vue&type=script&lang=js&"
import style0 from "./understanding-hair-structure.vue?vue&type=style&index=0&id=d5c01996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c01996",
  null
  
)

export default component.exports